<template>
  <div>
    <!-- Modal de Configuración del Árbol -->
    <TreeConfigModal v-if="isConfigModalOpen" :isOpen="isConfigModalOpen" @config-set="setTreeConfig" @update:isOpen="isConfigModalOpen = false" />
    <!-- Modal para mostrar información del nodo -->
    <NodeInfoModal v-if="currentNode && !isEditing" :node="currentNode" @close="closeModal" @edit="editNode" />
    <!-- Modal para editar nodo -->
    <NodeModal v-if="isEditing" :node="currentNode" @save="updateNode" @cancel="cancelEdit" />

    <!-- Diagrama con nodo raíz y ramas -->
    <div class="tree">
      <div class="config-header">
        <!-- Botón Configurar Árbol -->
        <v-btn class="botonA" @click="openConfigModal">Configurar Árbol</v-btn>

        <!-- Mostrar configuración actual en la parte superior -->
        <div class="config-info">
          <p><strong>Configuración del Árbol:</strong></p>
          <p>Número máximo de niveles: {{ maxLevels }}</p>
          <p>Número máximo de hijos por nodo: {{ maxChildren }}</p>
        </div>

        <!-- Botón Agregar Rama -->
        <v-btn class="botonA" @click="addChild(rootNode)">Agregar Rama</v-btn>
      </div>

      <div class="root-node">
        <div class="node" @click="showNodeInfo(rootNode)" :style="{ backgroundColor: '' || rootNode.color }">
          {{ rootNode.name }}
        </div>
        <div class="branch-container">
          <BracketDiagram
            v-for="(child, index) in rootNode.children"
            :key="index"
            :node="child"
            @showNodeInfo="showNodeInfo"
            @editNode="editNode"
            @addChild="addChild"
            @deleteNode="deleteNode"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BracketDiagram from '@/components/Arbol/BracketDiagram.vue'
import NodeInfoModal from '@/components/Arbol/NodeInfoModal.vue'
import NodeModal from '@/components/Arbol/NodeModal.vue'
import TreeConfigModal from '@/components/Arbol/TreeConfigModal.vue'

export default {
  components: { BracketDiagram, NodeInfoModal, NodeModal, TreeConfigModal },
  data () {
    return {
      rootNode: {
        name: 'Nodo Raíz',
        color: '#ff8000',
        clasificacion: 'Principal',
        children: []
      },
      currentNode: null,
      isEditing: false,
      originalNode: null,
      isConfigModalOpen: false,
      maxLevels: 0,
      maxChildren: 0
    }
  },
  methods: {
    openConfigModal () {
      this.isConfigModalOpen = true
    },
    setTreeConfig (config) {
      this.maxLevels = config.maxLevels
      this.maxChildren = config.maxChildren
    },
    showNodeInfo (node) {
      this.currentNode = node
    },
    closeModal () {
      this.currentNode = null
      this.isEditing = false
      this.originalNode = null
    },
    editNode (node) {
      this.currentNode = { ...node }
      this.originalNode = node
      this.isEditing = true
    },
    cancelEdit () {
      this.currentNode = { ...this.originalNode }
      this.closeModal()
    },
    updateNode (updatedNode) {
      const findAndUpdateNode = (node) => {
        if (node === this.originalNode) {
          Object.assign(node, updatedNode)
          return true
        }
        for (const child of node.children) {
          if (findAndUpdateNode(child)) return true
        }
        return false
      }

      findAndUpdateNode(this.rootNode)
      this.closeModal()
    },
    addChild (parentNode) {
      // Validar si el nodo padre puede agregar más hijos
      if (parentNode.children.length >= this.maxChildren) {
        alert('Este nodo ya tiene el máximo número de hijos permitido.')
        return
      }

      // Verificar si la profundidad del árbol supera el nivel máximo permitido
      const parentDepth = this.getNodeDepth(this.rootNode, parentNode)
      if (parentDepth >= this.maxLevels) {
        alert('Se alcanzó el número máximo de niveles permitidos.')
        return
      }

      // Si pasa la validación, agregar un nuevo nodo hijo
      parentNode.children.push({
        name: 'Nuevo Nodo',
        color: 'green',
        classification: 'Secundario',
        children: []
      })
    },
    deleteNode (nodeToDelete) {
      function removeNodeFromTree (tree, node) {
        tree.children = tree.children.filter(child => child !== node)
        tree.children.forEach(child => removeNodeFromTree(child, node))
      }
      removeNodeFromTree(this.rootNode, nodeToDelete)
    },
    getNodeDepth (root, node, currentDepth = 0) {
      // Encuentra la profundidad del nodo actual
      if (root === node) return currentDepth

      // Recorrer los hijos para encontrar la profundidad correcta
      for (const child of root.children) {
        const depth = this.getNodeDepth(child, node, currentDepth + 1)
        if (depth !== -1) {
          return depth
        }
      }
      return -1 // Nodo no encontrado
    }
  }
}
</script>

<style scoped>
.tree {
  padding-top: 10px;
  flex-direction: column;
  align-items: center;
}

.config-header {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 8px;
  padding: 10px;
  margin-bottom: 20px;
  background-color: #3949ab;
}

.botonA {
  margin: 0 10px;
  width: 170px;
  border-radius: 10px;
}

.root-node {
  padding-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.branch-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.node {
  background-color: #e0e0e0;
  font-size: 14px;
  border-radius: 5px;
  padding: 7px;
  cursor: pointer;
  text-align: center;
  min-width: 10px;
  margin-bottom: 30px;
}

.config-info {
  background-color: #f5f5f5;
  text-align: center;
  border-radius: 5px;
  padding: 10px;
  width: 300px;
}

.config-info p {
  margin: 3px 0;
}
</style>
